/*
 * Individuelles Angebot: lädt das Angebot zum ?key= aus dem Automation-Tool, zeigt die Positionen
 * als Produktkarten (im Stil der Bestseller-Karten) mit Übersicht und schickt den Kunden mit
 * „Jetzt bestellen“ in den Checkout der Draft Order, die das Automation-Tool dafür anlegt.
 *
 * Alles, was von der API kommt (Kundenname, Produkttitel, Attribute, Metafeld-Texte), wird per
 * textContent gesetzt, nie als HTML — der Name stammt aus dem amq-system und ist vom Kunden steuerbar.
 */
(function () {
  'use strict';

  var SVG = 'http://www.w3.org/2000/svg';
  var STERN = 'M31.547 12a.848.848 0 00-.677-.577l-9.427-1.376-4.224-8.532a.847.847 0 00-1.516 0l-4.218 8.534-9.427 1.355a.847.847 0 00-.467 1.467l6.823 6.664-1.612 9.375a.847.847 0 001.23.893l8.428-4.434 8.432 4.432a.847.847 0 001.229-.894l-1.615-9.373 6.822-6.665a.845.845 0 00.214-.869z';
  var HAKEN = 'M3.5 8.5l3 3 6-7';
  var zaehler = 0;

  function el(tag, className, text) {
    var e = document.createElement(tag);
    if (className) e.className = className;
    if (text !== undefined && text !== null) e.textContent = text;
    return e;
  }

  function svg(tag, attrs) {
    var e = document.createElementNS(SVG, tag);
    Object.keys(attrs).forEach(function (k) {
      e.setAttribute(k, attrs[k]);
    });
    return e;
  }

  function sprache() {
    return document.documentElement.lang || 'de-DE';
  }

  /**
   * Geldformat des Shops: Liquid gibt in den Texten 1234,56 im Format des aktuellen Markts aus
   * (z. B. „CHF 1,234.56“). Daraus kommen Zeichen und Trenner, damit Beträge genau so aussehen wie
   * auf den Produktseiten. Passt die Währung nicht, formatiert Intl.
   */
  var geldFormat = null;

  function geldFormatLesen(texte) {
    var m = /^(.*?)1(\D?)234(\D)56(.*)$/.exec(texte.geldMuster || '');
    geldFormat = m ? { waehrung: texte.geldWaehrung, vor: m[1], tausend: m[2], dezimal: m[3], nach: m[4] } : null;
  }

  function geld(betrag, waehrung) {
    if (geldFormat && geldFormat.waehrung === waehrung) {
      var teile = betrag.toFixed(2).split('.');
      return geldFormat.vor + teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, geldFormat.tausend) + geldFormat.dezimal + teile[1] + geldFormat.nach;
    }
    try {
      return new Intl.NumberFormat(sprache(), { style: 'currency', currency: waehrung || 'EUR' }).format(betrag);
    } catch (e) {
      return betrag.toFixed(2).replace('.', ',') + ' ' + (waehrung || 'EUR');
    }
  }

  function zahl(wert, stellen) {
    return new Intl.NumberFormat(sprache(), { minimumFractionDigits: stellen, maximumFractionDigits: stellen }).format(wert);
  }

  /** Shopify-CDN liefert auf Wunsch kleinere Bilder; die Karte braucht keine 2000 px. */
  function bildUrl(url) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=700';
  }

  function hakenSymbol() {
    var s = svg('svg', { viewBox: '0 0 16 16', fill: 'none', 'aria-hidden': 'true', focusable: 'false' });
    s.appendChild(svg('path', { d: HAKEN, stroke: 'currentColor', 'stroke-width': '2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' }));
    return s;
  }

  /** Sterne wie im Snippet amq_rating_stars: halber Stern bei x,3–x,7, darüber aufgerundet. */
  function sterne(bewertung, texte) {
    var max = Math.round(bewertung.max) || 5;
    var voll = Math.floor(bewertung.wert);
    var rest = bewertung.wert - voll;
    var halb = rest >= 0.3 && rest <= 0.7;
    if (rest > 0.7) voll += 1;
    var id = 'amq-angebot-halb-' + ++zaehler;

    var box = el('span', 'amq-angebot__sterne');
    box.setAttribute('role', 'img');
    box.setAttribute('aria-label', texte.bewertungLabel.replace('%WERT%', zahl(bewertung.wert, 2)).replace('%MAX%', String(max)));
    var stern = svg('svg', { width: '0', height: '0', 'aria-hidden': 'true', style: 'position:absolute' });
    var defs = svg('defs', {});
    var verlauf = svg('linearGradient', { id: id, x1: '0', x2: '100%', y1: '0', y2: '0' });
    verlauf.appendChild(svg('stop', { offset: '50%', 'stop-color': '#f5b301' }));
    verlauf.appendChild(svg('stop', { offset: '50%', 'stop-color': 'rgb(0 0 0 / 0.15)' }));
    defs.appendChild(verlauf);
    stern.appendChild(defs);
    box.appendChild(stern);
    for (var i = 1; i <= max; i++) {
      var fill = i <= voll ? '#f5b301' : halb && i === voll + 1 ? 'url(#' + id + ')' : 'rgb(0 0 0 / 0.15)';
      var s = svg('svg', { viewBox: '0 0 32 32', 'aria-hidden': 'true', focusable: 'false' });
      s.appendChild(svg('path', { d: STERN, fill: fill }));
      box.appendChild(s);
    }
    box.appendChild(el('span', 'amq-angebot__sterne-wert', zahl(bewertung.wert, 2)));
    box.appendChild(el('span', 'amq-angebot__sterne-anzahl', '(' + bewertung.anzahl.toLocaleString(sprache()) + ' ' + texte.bewertungen + ')'));
    return box;
  }

  /** Breite und Länge werden zu „Größe 180 × 200 cm“, „(in cm)“ wandert hinter den Wert. */
  function werte(attribute, texte, extra) {
    var liste = [];
    var breite = null;
    var laenge = null;
    attribute.forEach(function (a) {
      if (a.name === 'Breite (in cm)') breite = a.wert;
      else if (a.name === 'Länge (in cm)') laenge = a.wert;
    });
    if (breite && laenge) liste.push([texte.groesse, breite + ' × ' + laenge + ' cm']);
    attribute.forEach(function (a) {
      if (a.name === 'Breite (in cm)' || a.name === 'Länge (in cm)') return;
      if (a.name === 'Härtegradkombination') liste.push([texte.haertegrade, a.wert]);
      else if (/ \(in cm\)$/.test(a.name)) liste.push([a.name.replace(/ \(in cm\)$/, ''), a.wert + ' cm']);
      else liste.push([a.name, a.wert]);
    });
    (extra || []).forEach(function (e) {
      liste.push(e);
    });
    if (!liste.length) return null;
    var dl = el('dl', 'amq-angebot__werte');
    liste.forEach(function (paar) {
      dl.appendChild(el('dt', null, paar[0]));
      dl.appendChild(el('dd', null, paar[1]));
    });
    return dl;
  }

  /** Mit Varianten-ID wählt die Produktseite genau die angebotene Größe und den Härtegrad vor. */
  function produktUrl(handle, varianteId) {
    var url = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'products/' + encodeURIComponent(handle);
    return varianteId ? url + '?variant=' + encodeURIComponent(varianteId) : url;
  }

  function karte(position, texte, waehrung) {
    var k = el('article', 'amq-angebot__karte');

    var media = el(position.handle ? 'a' : 'div', 'amq-angebot__media');
    if (position.handle) {
      media.href = produktUrl(position.handle, position.varianteId);
      media.tabIndex = -1;
      media.setAttribute('aria-hidden', 'true');
    }
    if (position.bild) {
      var img = el('img');
      img.src = bildUrl(position.bild);
      img.alt = position.titel;
      img.loading = 'lazy';
      media.appendChild(img);
    }
    if (position.badge) media.appendChild(el('span', 'amq-angebot__badge', position.badge));
    k.appendChild(media);

    var inhalt = el('div', 'amq-angebot__karte-inhalt');
    var titel = el('h2', 'amq-angebot__produkt');
    if (position.handle) {
      var link = el('a', null, position.titel);
      link.href = produktUrl(position.handle, position.varianteId);
      titel.appendChild(link);
    } else {
      titel.textContent = position.titel;
    }
    inhalt.appendChild(titel);

    if (position.bewertung) {
      var sternZeile = sterne(position.bewertung, texte);
      if (position.handle) {
        // Öffnet das Bewertungs-Popup (assets/amq-bewertungen.js reagiert auf data-amq-bewertungen).
        var knopf = el('button', 'amq-angebot__sterne-knopf');
        knopf.type = 'button';
        knopf.setAttribute('data-amq-bewertungen', position.handle);
        knopf.setAttribute('aria-label', sternZeile.getAttribute('aria-label') + ' – ' + texte.bewertungenOeffnen);
        sternZeile.removeAttribute('role');
        sternZeile.removeAttribute('aria-label');
        knopf.appendChild(sternZeile);
        inhalt.appendChild(knopf);
      } else {
        inhalt.appendChild(sternZeile);
      }
    }
    if (position.verkaufsargument) inhalt.appendChild(el('p', 'amq-angebot__argument', position.verkaufsargument));

    if (position.hinweis) {
      var hinweis = el('p', 'amq-angebot__kern');
      hinweis.appendChild(el('strong', null, position.hinweis.titel));
      hinweis.appendChild(document.createElement('br'));
      hinweis.appendChild(document.createTextNode(position.hinweis.text));
      inhalt.appendChild(hinweis);
    }

    if (position.teile && position.teile.length) {
      inhalt.appendChild(el('p', 'amq-angebot__mwst-klein', texte.zusammengesetzt));
      var teile = el('ul', 'amq-angebot__teile');
      position.teile.forEach(function (t) {
        var li = el('li', 'amq-angebot__teil');
        li.appendChild(el('span', 'amq-angebot__teil-marke', t.rolle));
        var text = el('span', null, t.titel);
        var details = t.attribute
          .map(function (a) {
            return a.wert;
          })
          .join(' · ');
        if (details) text.appendChild(el('small', null, details));
        li.appendChild(text);
        teile.appendChild(li);
      });
      inhalt.appendChild(teile);
    }

    var tabelle = werte(position.attribute, texte, position.lieferzeit ? [[texte.lieferzeit, position.lieferzeit]] : []);
    if (tabelle) inhalt.appendChild(tabelle);

    if (position.vorteile && position.vorteile.length) {
      var details = el('details', 'amq-angebot__vorteile');
      details.appendChild(el('summary', null, texte.vorteile));
      var liste = el('ul', 'amq-angebot__haken');
      position.vorteile.forEach(function (v) {
        var li = el('li');
        li.appendChild(hakenSymbol());
        li.appendChild(el('span', null, v));
        liste.appendChild(li);
      });
      details.appendChild(liste);
      inhalt.appendChild(details);
    }

    var preis = el('div', 'amq-angebot__preiszeile');
    preis.appendChild(el('span', 'amq-angebot__mwst-klein', texte.inklMwst));
    preis.appendChild(el('span', 'amq-angebot__preis', geld(position.preis, waehrung)));
    inhalt.appendChild(preis);

    k.appendChild(inhalt);
    return k;
  }

  /** Text zur Fehlerantwort der API. Bei 422 ist die Meldung der API die genaueste. */
  function fehlertext(status, body, texte) {
    if (status === 400) return texte.fehlerLink;
    if (status === 404) return texte.fehlerNichtGefunden;
    if (status === 409) return texte.bereitsBestellt;
    if (status === 429) return texte.zuVieleAnfragen;
    if (status === 422 && body && body.meldung) return body.meldung;
    return texte.fehlerAllgemein;
  }

  function init(root) {
    if (root.dataset.amqAngebotReady === '1') return;
    root.dataset.amqAngebotReady = '1';

    var texte = JSON.parse(root.querySelector('[data-amq-angebot-texte]').textContent);
    geldFormatLesen(texte);
    var api = (root.dataset.api || '').replace(/\/+$/, '');
    var key = (new URLSearchParams(window.location.search).get('key') || '').trim();

    var titel = root.querySelector('[data-amq-angebot-titel]');
    var einleitung = root.querySelector('[data-amq-angebot-einleitung]');
    var laden = root.querySelector('[data-amq-angebot-laden]');
    var meldung = root.querySelector('[data-amq-angebot-meldung]');
    var meldungText = root.querySelector('[data-amq-angebot-meldung-text]');
    var inhalt = root.querySelector('[data-amq-angebot-inhalt]');
    var raster = root.querySelector('[data-amq-angebot-raster]');
    var zeilen = root.querySelector('[data-amq-angebot-zeilen]');
    var summe = root.querySelector('[data-amq-angebot-summe]');
    var bestellen = root.querySelector('[data-amq-angebot-bestellen]');
    var bestellenText = bestellen.textContent;

    function zeigeMeldung(text, erfolg) {
      laden.hidden = true;
      meldungText.textContent = text;
      meldung.classList.toggle('amq-angebot__meldung--erfolg', !!erfolg);
      meldung.querySelector('[data-symbol-fehler]').hidden = !!erfolg;
      meldung.querySelector('[data-symbol-erfolg]').hidden = !erfolg;
      meldung.hidden = false;
      meldung.focus();
    }

    function antwortLesen(res) {
      return res
        .json()
        .catch(function () {
          return null;
        })
        .then(function (body) {
          return { status: res.status, body: body };
        });
    }

    if (!key) {
      zeigeMeldung(texte.fehlerLink);
      return;
    }

    fetch(api + '/angebot?key=' + encodeURIComponent(key), { headers: { Accept: 'application/json' } })
      .then(antwortLesen)
      .then(function (r) {
        if (r.status !== 200 || !r.body || !r.body.ok) {
          zeigeMeldung(fehlertext(r.status, r.body, texte), r.status === 409);
          return;
        }
        var angebot = r.body;
        if (!texte.titel && angebot.kundenname) {
          titel.textContent = texte.titelMitName.replace('%NAME%', angebot.kundenname);
        }
        raster.classList.toggle('amq-angebot__raster--einzeln', angebot.positionen.length === 1);
        angebot.positionen.forEach(function (p) {
          raster.appendChild(karte(p, texte, angebot.waehrung));
          var zeile = el('li');
          var name = el('span', null, p.titel);
          if (p.art === 'nurKern') name.appendChild(el('small', null, texte.nurKern));
          zeile.appendChild(name);
          zeile.appendChild(el('span', null, geld(p.preis, angebot.waehrung)));
          zeilen.appendChild(zeile);
        });
        summe.textContent = geld(angebot.summe, angebot.waehrung);
        laden.hidden = true;
        einleitung.hidden = false;
        inhalt.hidden = false;
      })
      .catch(function () {
        zeigeMeldung(texte.fehlerAllgemein);
      });

    bestellen.addEventListener('click', function () {
      bestellen.disabled = true;
      bestellen.textContent = texte.wirdVorbereitet;
      meldung.hidden = true;

      fetch(api + '/checkout', {
        method: 'POST',
        // Formular statt JSON: ein Simple Request ohne CORS-Preflight.
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: new URLSearchParams({ key: key }).toString(),
      })
        .then(antwortLesen)
        .then(function (r) {
          if (r.status === 200 && r.body && r.body.ok && r.body.url) {
            window.location.assign(r.body.url);
            return;
          }
          if (r.status === 409) bestellen.hidden = true;
          zeigeMeldung(fehlertext(r.status, r.body, texte), r.status === 409);
          bestellen.disabled = false;
          bestellen.textContent = bestellenText;
        })
        .catch(function () {
          zeigeMeldung(texte.fehlerAllgemein);
          bestellen.disabled = false;
          bestellen.textContent = bestellenText;
        });
    });
  }

  function alle() {
    document.querySelectorAll('[data-amq-angebot]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }
  document.addEventListener('shopify:section:load', alle);
})();
